import { AvailableDefectLayersQuery } from '../contracts/availableLayers';
import { SurveyDataManagerDashboardStatsQuery } from '../contracts/dashboardStats';

const ROOT = ['surveyDataManager'] as const;

export function toDashboardStatsQueryKey(
  query: SurveyDataManagerDashboardStatsQuery = {},
): readonly [string, string, string] {
  return [query.surveyType ?? '', query.surveyYear ?? '', query.lane ?? ''];
}

export const surveyDataManagerQueryKeys = {
  root: ROOT,
  defectsStatisticsAll: () => [...ROOT, 'defects', 'statistics'] as const,
  defectsStatistics: (query: SurveyDataManagerDashboardStatsQuery = {}) =>
    [
      ...surveyDataManagerQueryKeys.defectsStatisticsAll(),
      ...toDashboardStatsQueryKey(query),
    ] as const,
  defects: (
    query: AvailableDefectLayersQuery = {},
    tenantSlug: string | null = null,
  ) =>
    [
      ...ROOT,
      'defects',
      'list',
      'band-meanings-v2',
      tenantSlug ?? '',
      query,
    ] as const,
  defectRulesets: (slug: string) => [...ROOT, 'defects', slug, 'rulesets'] as const,
  defectRuleset: (slug: string, rulesetSlug: string) =>
    [...ROOT, 'defects', slug, 'rulesets', rulesetSlug] as const,
  defectRules: (slug: string, rulesetSlug: string, measurementSlug?: string) =>
    [
      ...ROOT,
      'defects',
      slug,
      'rulesets',
      rulesetSlug,
      'rules',
      measurementSlug ?? '',
    ] as const,
  defectFeatures: (slug: string, measurement: string, surveyYear: string, lane: string = '') =>
    [...ROOT, 'defects', slug, 'features', measurement, surveyYear, lane] as const,
  defectRule: (slug: string, rulesetSlug: string, ruleSlug: string) =>
    [...ROOT, 'defects', slug, 'rulesets', rulesetSlug, 'rules', ruleSlug] as const,
  activeLayerVisualizationSettings: (instanceId: string) =>
    [...ROOT, 'activeLayers', instanceId, 'visualizationMeasureSettings'] as const,
  availableViews: (tenantSlug: string | null = null) =>
    [...ROOT, 'availableViews', 'legend-v3', tenantSlug ?? ''] as const,
};
